import apiService, { APIResponse } from "./axios";

import { store } from "../../store/store"; // Pfad zu deinem Store-File
import { setOffers } from "../../store/orm/offers";

class OffersService {
  async fetchOffers() {
    const response: APIResponse<any> =
      await apiService.get<any>("api/rent/offers");

    if (response.error) {
      console.error("Fehler:", response.message);
      return;
    }

    store.dispatch(setOffers(response as any));
  }
}

const ormOffersService = new OffersService();
export default ormOffersService;
